import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Features from "./features/Features";
import Hiring_Partners from "./hiring-partners/Hiring_Partners";
import Achievements from "./achievements/Achievements";
import Industry_Experts from "./industry-experts/Industry_Experts";
import PST_Academy from "./pst-academy/PST_Academy";
import Loved_By_Learners from "./loved-by-learners/Loved_By_Learners";
import PST_IT_Solutions from "./pst-it-solutions/PST_IT_Solutions";
import Integrated_Institute from "./integrated-institute/Integrated_Institute";
import Placement_Support from "./placement-support/Placement_Support";
import Industry_Standard from "./industry-standard/Industry_Standard";
import Carrer_Tooksoff from "./carrer-tooksoff/Carrer_Tooksoff";
import Unlock_Your_Potential from "./unlock-your-potential/Unlock_Your_Potential";
import Contact_Section from "./contact-section/Contact_Section";
import PST_Spotlight from "./pst-spotlight/PST_Spotlight";
import Learn_Something_New from "./learn-something-new/Learn_Something_New";
import Our_Blogs from "./our-blogs/Our_Blogs";
import FAQ from "./faq/FAQ";
import { AllBannerText, AllBlogs, AllHomeImage } from "../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { ShimmerPostItem } from "react-shimmer-effects";

function Home() {
  const dispatch = useDispatch();
  const all_banner_text = useSelector(
    (state) => state?.common?.all_banner_text,
  );

  const all_home_image = useSelector(
    (state) => state?.common?.all_home_image,
  );
    console.log(all_home_image, "Home Image");


  const blogs = useSelector((state) => state?.common?.all_blogs);

  useEffect(() => {
    dispatch(AllBannerText());
    dispatch(AllBlogs());
    dispatch(AllHomeImage());
  }, [dispatch]);
  return (
    <>

      <Banner all_banner_text={all_banner_text}  all_home_image={all_home_image}/>

      <Features />
      <Achievements />
      <Hiring_Partners />
      <Industry_Experts />
      <PST_Academy />
      <Loved_By_Learners />
      <PST_IT_Solutions />
      <Integrated_Institute />
      <Placement_Support />
      <Industry_Standard />
      <Carrer_Tooksoff />
      <Unlock_Your_Potential />
      <Contact_Section />
      <PST_Spotlight />
      <Learn_Something_New />
      <Our_Blogs blogs={blogs} />
      <FAQ />
    </>
  );
}

export default Home;
